/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  FinancialPlanFundingRequestDecisionType,
  FinancialPlanFundingRequestDecisionTypeFromJSON,
  FinancialPlanFundingRequestDecisionTypeFromJSONTyped,
  FinancialPlanFundingRequestDecisionTypeToJSON,
} from "./FinancialPlanFundingRequestDecisionType";

/**
 *
 * @export
 * @interface FinancialPlanUpdateFundingRequestDecisionRequestDto
 */
export interface FinancialPlanUpdateFundingRequestDecisionRequestDto {
  /**
   *
   * @type {FinancialPlanFundingRequestDecisionType}
   * @memberof FinancialPlanUpdateFundingRequestDecisionRequestDto
   */
  decisionType: FinancialPlanFundingRequestDecisionType;
  /**
   *
   * @type {number}
   * @memberof FinancialPlanUpdateFundingRequestDecisionRequestDto
   */
  amount: number;
}

export function FinancialPlanUpdateFundingRequestDecisionRequestDtoFromJSON(
  json: any
): FinancialPlanUpdateFundingRequestDecisionRequestDto {
  return FinancialPlanUpdateFundingRequestDecisionRequestDtoFromJSONTyped(json, false);
}

export function FinancialPlanUpdateFundingRequestDecisionRequestDtoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): FinancialPlanUpdateFundingRequestDecisionRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    decisionType: FinancialPlanFundingRequestDecisionTypeFromJSON(json["decisionType"]),
    amount: json["amount"],
  };
}

export function FinancialPlanUpdateFundingRequestDecisionRequestDtoToJSON(
  value?: FinancialPlanUpdateFundingRequestDecisionRequestDto | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    decisionType: FinancialPlanFundingRequestDecisionTypeToJSON(value.decisionType),
    amount: value.amount,
  };
}
